import React, { useState } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link, NavLink } from "react-router-dom";
import { SidebarData } from "../data/SidebarData";
import "../App.css";
import { IconContext } from "react-icons";
import { hasAnyPermission, useAuth } from "../services/auth";

function Navbar() {
  const [sidebar, setSidebar] = useState(false);
  const [user] = useAuth();

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: "undefined" }}>
        <div className="navbar">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
        </div>
        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.filter((item) => {
              if (!item.permissions) return true;
              if (user?.permissions?.includes("warehouse_no_access")) return false;
              return hasAnyPermission(user, item.permissions);
            }).map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <NavLink to={item.path} className={({ isActive }) => isActive ? "active" : undefined}>
                    {item.icon}
                    <span className="nav-item">{item.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
